module.exports = __webpack_public_path__ + "img/bonus-list@3x.30d9e002.png";